export default __webpack_public_path__ + "static/media/16t.120d7c13.jpg";